import { useDispatch } from 'react-redux';
import { resetPopupContentAction, setPopupContentAction } from '~/src/redux/popups/popups.slice';
import { revertAllLeadReferralData } from '~/src/redux/actions';
import type { ReactElement } from 'react';

export const usePopupContent = () => {
    const dispatch = useDispatch();

    const resetPopup = () => {
        dispatch(resetPopupContentAction());
    };

    const buttonCallback = () => {
        dispatch(revertAllLeadReferralData());
    };

    const showPopup = (Popup: ReactElement) => {
        dispatch(setPopupContentAction({ content: Popup, replace: true }));
    };

    return {
        resetPopup,
        buttonCallback,
        showPopup,
    };
};
